import { createActionTypes } from 'utils/action/actionTypes';

export const GET_SUBSCRIPTION = createActionTypes('GET_SUBSCRIPTION');
